import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const CopyIconSvg = (<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 9.5H6.5C6.23478 9.5 5.98043 9.60536 5.79289 9.79289C5.60536 9.98043 5.5 10.2348 5.5 10.5V21.5C5.5 21.7652 5.60536 22.0196 5.79289 22.2071C5.98043 22.3946 6.23478 22.5 6.5 22.5H17.5C17.7652 22.5 18.0196 22.3946 18.2071 22.2071C18.3946 22.0196 18.5 21.7652 18.5 21.5V20M10.5 18.5H21.5C21.7652 18.5 22.0196 18.3946 22.2071 18.2071C22.3946 18.0196 22.5 17.7652 22.5 17.5V6.5C22.5 6.23478 22.3946 5.98043 22.2071 5.79289C22.0196 5.60536 21.7652 5.5 21.5 5.5H10.5C10.2348 5.5 9.98043 5.60536 9.79289 5.79289C9.60536 5.98043 9.5 6.23478 9.5 6.5V17.5C9.5 17.7652 9.60536 18.0196 9.79289 18.2071C9.98043 18.3946 10.2348 18.5 10.5 18.5Z"
            stroke="currentColor"/>
    </svg>


)
const CopyIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {CopyIconSvg}
    </SvgIcon>
);
export default CopyIcon